import { useFetcher } from "~/hooks/useFetcher";
import {
  QuickActionCard,
  QuickActionPlacement,
  quickActionsAvailablePath,
} from "~/services/quickActions";

const EMPTY_ACTIONS: QuickActionCard[] = [];

/**
 * Quick actions are a "nice to have" suggestion rail, not core content, so any
 * fetch failure (missing `use:agents`, a transient 500, ...) just hides the
 * section rather than surfacing an error state.
 */
export const useQuickActions = (placement: QuickActionPlacement, placementId?: string) => {
  const { data, error, isLoading } = useFetcher<QuickActionCard[]>(
    quickActionsAvailablePath(placement, placementId)
  );

  return {
    actions: error ? EMPTY_ACTIONS : (data ?? EMPTY_ACTIONS),
    isLoading,
  };
};
